var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from "react";
import { Grid, Typography } from "@material-ui/core";
const FormSection = (_a) => {
    var { title, children } = _a, props = __rest(_a, ["title", "children"]);
    return (React.createElement(Fragment, null,
        React.createElement(Typography, { variant: "h6" }, title),
        React.createElement("div", Object.assign({ className: "FormContainer" }, props),
            React.createElement(Grid, { container: true, spacing: 3 }, children))));
};
export default FormSection;
